import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import Avatar from '../Avatar';
import {
  onUpdateSearchByOrder,
  getCustomer,
  logout,
  autoAssignOpeningHours,
  displayNewBooking,
  hideNewBooking,
  setQuickOrderFormOpen,
} from '../../actions';
import './style.scss';
import { Translate, Logo, RouteLeavingModal } from '../../../Share/components';
import BookNowModal from '../BookNowModal';
import NotificationContainer from '../NotificationContainer';
import { preventScrollWhenVisible } from '../../../Share/utils';
import { NavigateService } from '../../../Share/services/navigationService';
import Information from '../Information';

const propTypes = {
  interpreterId: PropTypes.string,
  mapOnUpdateSearchByOrder: PropTypes.func,
  profile: PropTypes.shape({}),
  bookDirectOpeningHours: PropTypes.shape({}),
  displayKPIReports: PropTypes.bool,
  showBookDirectModal: PropTypes.bool,
  onGetCustomer: PropTypes.func,
  onLogout: PropTypes.func,
  getAutoAssignOpeningHours: PropTypes.func,
  onClickNavigationButton: PropTypes.func,
  CanCreateAutoAssignOrder: PropTypes.bool,
  onCreateNewBooking: PropTypes.func,
  onHideNewBooking: PropTypes.func,
  onSetQuickOrderFormOpen: PropTypes.func,
  handleBookDirectModal: PropTypes.func,
  navigationRef: PropTypes.object,
  location: PropTypes.object,
  navigate: PropTypes.func,
  displayNewBooking: PropTypes.bool,
  isQuickOrderFormOpen: PropTypes.bool,
};

const defaultProps = {
  interpreterId: '',
  mapOnUpdateSearchByOrder: () => {},
  profile: {},
  displayKPIReports: false,
  showBookDirectModal: false,
  CanCreateAutoAssignOrder: false,
  onGetCustomer: () => {},
  bookDirectOpeningHours: {},
  getAutoAssignOpeningHours: () => {},
  onLogout: () => {},
  onClickNavigationButton: () => {},
  onCreateNewBooking: () => {},
  onHideNewBooking: () => {},
  onSetQuickOrderFormOpen: () => {},
  handleBookDirectModal: () => {},
  navigationRef: null,
  location: null,
  navigate: () => {},
  displayNewBooking: false,
  isQuickOrderFormOpen: false,
};

const INITAL_STATES = {
  searchOrder: '',
  isSearchInMenu: false,
  bookNowModalVisible: false,
  showRouteLeavingModal: false,
};

class RightStatus extends Component {
  static propTypes = {
    ...propTypes,
    location: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
  };

  static defaultProps = defaultProps;

  constructor(props) {
    super(props);
    this.state = INITAL_STATES;
  }

  componentDidMount() {
    this.ismounted = true;
    this.checkNewEmergencyBooking(this.props.location.pathname);
    // document.addEventListener('keydown', this.handleNewBooking);
  }

  componentDidUpdate(prevProps) {
    const { showBookDirectModal, getAutoAssignOpeningHours } = this.props;
    if (
      prevProps.showBookDirectModal !== showBookDirectModal &&
      showBookDirectModal
    ) {
      getAutoAssignOpeningHours({
        DateFrom: moment().format('YYYY-MM-DD'),
        DateTo: moment().format('YYYY-MM-DD'),
      });
    }
  }

  componentWillUnmount() {
    this.ismounted = false;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.searchOrder === '' && !prevState.isSearchInMenu) {
      return {
        searchOrder: '',
      };
    }
    return null;
  }

  handleUpdateOrder = event => {
    this.setState({
      searchOrder: event.target.value,
      isSearchInMenu: true,
    });
  };

  handleBookNowModal = () => {
    const { bookNowModalVisible } = this.state;
    this.setState({
      bookNowModalVisible: !bookNowModalVisible,
    });
  };

  handleSubmitSearch = () => {
    const { mapOnUpdateSearchByOrder } = this.props;
    this.setState({
      isSearchInMenu: false,
    });
    mapOnUpdateSearchByOrder(this.state.searchOrder);
    NavigateService.goToPath('/search-result');
  };

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleSubmitSearch();
    }
  }

  onClickNavigationButton = event => {
    this.props.onClickNavigationButton(event);
    preventScrollWhenVisible(true);
  };

  checkNewEmergencyBooking = path => {
    if (path === '/new-emergency-booking') {
      this.props.handleBookDirectModal();
    }
  };

  showNewBooking = () => {
    const { navigate, onCreateNewBooking, onSetQuickOrderFormOpen, location } =
      this.props;
    const currentPath = location.pathname;
    if (currentPath !== '/') {
      navigate('/');
    }
    onSetQuickOrderFormOpen(true);
    onCreateNewBooking();
  };

  handleBookDirectClick = () => {
    const { isQuickOrderFormOpen, handleBookDirectModal } = this.props;
    if (isQuickOrderFormOpen) {
      this.setState({
        showRouteLeavingModal: true,
      });
    } else {
      handleBookDirectModal();
    }
  };

  handleRouteLeavingModalClose = () => {
    this.setState({
      showRouteLeavingModal: false,
      displayNewBooking: false,
      isDirty: false,
    });
  };

  handleRouteLeavingModalConfirm = () => {
    const { handleBookDirectModal, onHideNewBooking, onSetQuickOrderFormOpen } =
      this.props;
    this.setState({
      showRouteLeavingModal: false,
      displayNewBooking: false,
      isDirty: false,
    });
    onHideNewBooking();
    onSetQuickOrderFormOpen(false);

    handleBookDirectModal();
  };

  render() {
    const { searchOrder, showRouteLeavingModal } = this.state;
    const {
      showBookDirectModal,
      handleBookDirectModal,
      CanCreateAutoAssignOrder,
      bookDirectOpeningHours,
      navigationRef,
    } = this.props;
    const setNavLinkClassName = ({ isActive, location }) => {
      const baseClass = 'nav-item';
      return isActive || (location && /submit-time/.test(location.pathname))
        ? `${baseClass} nav-active`
        : baseClass;
    };
    return (
      <div className="tv-right-status" id="navigation" ref={navigationRef}>
        <Logo />
        <div className="flex-grow-1 tv-bookDirect-button-nav__wrapper direct-booking-wrapper">
          {CanCreateAutoAssignOrder && (
            <button
              className="booking-button tv-display-mobile-hide"
              onClick={this.handleBookDirectClick}
              tabIndex={0}
              title="Boka tolk innevarande dag"
            >
              <i className="fa fa-plus mr-2" />
              Akut tolk
            </button>
          )}
        </div>
        <div className="tv-bookDirect-button-nav__wrapper ml-3 quick-booking-wrapper">
          <button
            className="booking-button tv-display-mobile-hide"
            onClick={this.showNewBooking}
            tabIndex={0}
            title="Boka tolk övrig tid"
          >
            <i className="fa fa-plus mr-2" />
            Ny bokning
          </button>
        </div>
        <div className=" navigation">
          <nav className="navbar-expand">
            <div className="navbar-nav">
              <NavLink
                onClick={this.onClickNavItem}
                className={setNavLinkClassName}
                end
                to="/"
              >
                <Translate content="sideBar.dashboard" />
              </NavLink>
              {this.props.displayKPIReports ? (
                <NavLink
                  className={setNavLinkClassName}
                  end
                  to="/reports-dashboard/"
                >
                  {Translate({
                    content: 'report.statistics',
                  })}
                </NavLink>
              ) : null}

              <NavLink className={setNavLinkClassName} end to="/translation">
                {Translate({
                  content: 'sideBar.translations',
                })}
              </NavLink>
              <NavLink className={setNavLinkClassName} end to="/my-assignment">
                {Translate({
                  content: 'sideBar.myAssignment',
                })}
              </NavLink>
              <NavLink
                className={setNavLinkClassName}
                end
                to={{
                  pathname: '/report-quality',
                  state: { isGeneral: true },
                }}
              >
                <Translate content="sideBar.reportQuality" />
              </NavLink>
              <NavLink
                to="#"
                className="nav-item"
                aria-label="Vanliga frågor och svar"
                onClick={e => {
                  e.preventDefault();
                  window.open(
                    'https://www.tolkformedlingvast.se/vara-tjanster/spraktolkning/vanliga-fragor-och-svar.html',
                    '_blank',
                    'noopener,noreferrer',
                  );
                }}
              >
                Frågor och svar
              </NavLink>
              <NavLink className={setNavLinkClassName} end to="/ai-tolk">
                <span>
                  <Translate content="sideBar.aiTalk" />
                </span>
              </NavLink>
              <NavLink className={setNavLinkClassName} end to="/contact-tfv">
                <span>
                  <Translate content="sideBar.contactTFV" />
                </span>
              </NavLink>
            </div>
          </nav>
        </div>

        {showBookDirectModal && !isEmpty(bookDirectOpeningHours) && (
          <BookNowModal
            isVisible={showBookDirectModal}
            onCloseClicked={handleBookDirectModal}
            bookDirectOpeningHours={bookDirectOpeningHours}
          />
        )}

        <NotificationContainer />
        <Information />
        <div className=" mobile-nav position-relative text-right">
          <Avatar
            interpreterId={this.props.interpreterId}
            profile={this.props.profile}
            getCustomer={this.props.onGetCustomer}
            logout={this.props.onLogout}
            visibleName={false}
          />
          <button
            onClick={this.onClickNavigationButton}
            className="menu-button fa fa-bars"
            aria-label="menu button"
          />
        </div>

        <RouteLeavingModal
          isVisible={showRouteLeavingModal}
          onCloseClicked={this.handleRouteLeavingModalClose}
          onOverlayClick={this.handleRouteLeavingModalClose}
          onConfirmClick={this.handleRouteLeavingModalConfirm}
          message="Dina ändringar kommer inte att sparas."
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  interpreterId: state.authentication.interpreterId,
  profile: state.user.profile,
  searchOrder: state.workAssignment.searchOrder,
  bookDirectOpeningHours: state.workAssignment.bookDirectOpeningHours,
  displayNewBooking: state.dashboard.displayNewBooking,
  isQuickOrderFormOpen: state.workAssignment.isQuickOrderFormOpen,
});

const mapDispatchToProps = dispatch => ({
  mapOnUpdateSearchByOrder: searchOrder => {
    dispatch(onUpdateSearchByOrder(searchOrder));
  },
  onGetCustomer: () => {
    dispatch(getCustomer());
  },
  onLogout: () => {
    dispatch(logout());
  },
  getAutoAssignOpeningHours: dateObj => {
    dispatch(autoAssignOpeningHours(dateObj));
  },
  onCreateNewBooking: () => {
    dispatch(displayNewBooking());
  },
  onHideNewBooking: () => {
    dispatch(hideNewBooking());
  },
  onSetQuickOrderFormOpen: isOpen => {
    dispatch(setQuickOrderFormOpen(isOpen));
  },
});

// Create a wrapper component that uses hooks
const RightStatusWithRouter = props => {
  const location = useLocation();
  const navigate = useNavigate();

  return <RightStatus {...props} location={location} navigate={navigate} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RightStatusWithRouter);
